import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { uploadFile } from "../lib/api/files";
import { queryClient } from "../lib/queryClient";
import { qk } from "../lib/queryKeys";
import { useToast } from "../providers/ToastProvider";
import type { FileDTO } from "../lib/api/types";

export function useUploadFile(folderId: string | null) {
  const { push } = useToast();
  const [progress, setProgress] = useState<number>(0);

  const mutation = useMutation<FileDTO, unknown, { file: File }>({
    mutationFn: ({ file }) => {
      setProgress(0);
      return uploadFile({
        folderId,
        file,
        onProgress: (percent) => setProgress(percent),
      });
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: qk.contents(folderId) });
      push({ kind: "success", message: "Upload complete" });
    },
    onSettled: () => {
      setProgress(0);
    },
  });

  return { ...mutation, progress };
}
